import { organizationsId } from "@papier/auth-schema";
import { z } from "zod";
import { USER_ROLES } from "./auth.enums";

const createUser = z.object({
  name: z.string().min(1),
  email: z.string().email(),
  password: z.string().min(4),
  role: z.enum(USER_ROLES),
  autoVerify: z.boolean(),
});
export type UserCreateSchema = z.infer<typeof createUser>;

export default {
  createUser,
  getUsersAdmin: z.object({
    email: z.string().optional(),
    role: z.enum(["all", "admin", "user"]).optional(),
    page: z.number().min(1).default(1),
    limit: z.number().min(1).max(100).default(10),
    sortBy: z.string().optional(),
    sortDirection: z.enum(["asc", "desc"]).optional(),
  }),
  getOrganizationsAdmin: z.object({
    name: z.string().optional(),
    page: z.number().min(1).default(1),
    plan: z.string().optional(),
    limit: z.number().min(1).max(100).default(10),
    sortBy: z.string().optional(),
    sortDirection: z.enum(["asc", "desc"]).optional(),
  }),
  deleteOrganization: z.object({
    organizationId: organizationsId,
  }),
};
